import React from 'react';
import { Icon } from './Icons.jsx';

export function CreditConfirmationModal({ open, title = 'Confirm plan quota', description = 'This action uses plan quota.', creditCost = 1, creditUsage = null, confirming = false, confirmLabel = 'Confirm', confirmingLabel = 'Confirming...', onConfirm, onCancel, onBuyCredits, onUpgrade, children }) {
  if (!open) return null;
  const remaining = creditUsage?.remaining;
  const limit = creditUsage?.limit;
  const hasUnlimited = remaining === null || limit === null;
  const hasEnough = hasUnlimited || remaining === undefined || Number(remaining) >= Number(creditCost || 0);
  return (
    <div className="modal-scrim" role="presentation">
      <div className="modal card" role="dialog" aria-modal="true" aria-labelledby="credit-confirm-title">
        <div className="type-icon"><Icon name="creditCard" size={18} /></div>
        <h3 id="credit-confirm-title" className="h3">{title}</h3>
        <p className="body-sm" style={{ color: 'var(--text-2)' }}>{description}</p>
        {children}
        <div className="auth-note" style={{ marginTop: 12 }}><Icon name="sparkles" size={13} /> This will reserve <strong>{creditCost}</strong> {creditCost === 1 ? 'unit' : 'units'} of plan output quota.{creditUsage && <span> You have {hasUnlimited ? 'unlimited quota' : `${remaining} remaining`}.</span>}</div>
        {!hasEnough && <div className="auth-error" style={{ marginTop: 12 }}><Icon name="alert" size={13} /> Not enough plan quota for this action.</div>}
        <div className="row gap-8" style={{ marginTop: 16, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
          <button type="button" className="btn btn-primary" onClick={onConfirm} disabled={confirming || !hasEnough}>{confirming ? confirmingLabel : confirmLabel}</button>
          <button type="button" className="btn btn-secondary" onClick={onBuyCredits || onUpgrade} disabled={confirming}>View plans</button>
          <button type="button" className="btn btn-ghost" onClick={onCancel} disabled={confirming}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
